import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Form,
  Input,
  Select,
  Row,
  Col,
  Typography,
  Card,
  InputNumber,
  Radio,
  Empty,
  Tabs,
} from "antd";
import CardComponent from "../components/cardComponent";
import useUserDetails from "../utils/useUserDetails";
import { postReq } from "../api";
import { notification } from "antd";
const { Option } = Select;
const { Title, Text } = Typography;
const Requirements = () => {
  const [activeTab, setActiveTab] = useState("open");
  const [query, setQuery] = useState({
    page: 1,
    limit: 100,
    searchParams: "",
  });

  const [jobData, setJobData] = useState([]);
  const [number, setNumber] = useState({ open: 0, close: 0, "on-hold": 0 });
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [requiredTechOptions, setRequiredTechOptions] = useState([]);
  const [techNicheOptions, setTechNicheOptions] = useState([]);
  const [isSearch, setIsSearch] = useState(true);

  const [candidate, setCandidate] = useState([]);
  const [client, setClients] = useState([]);
  const { userRole, userDetails, permissions } = useUserDetails();

  const requirementTypeOptions = [
    {
      value: "Fte",
      _id: "Fte",
    },
    {
      value: "Contractual",
      _id: "Contractual",
    },
  ];

  const handleTagsData = async (isRequiredTech) => {
    try {
      // let { _id } = JSON.parse(localStorage.getItem("companyDetails"));

      let type = isRequiredTech ? "requiredTech" : "techNiche";

      const callResponse = await postReq("/common/getTags", {
        type: type,
        // companyId: _id,
      });
      if (callResponse.status == 1) {
        if (isRequiredTech) {
          setRequiredTechOptions(callResponse.data.tags);
        } else {
          setTechNicheOptions(callResponse.data.tags);
        }
      }
    } catch (error) {
      console.log("error ", error);
    }
  };

  const fetchClient = async () => {
    let response;
    response =
      userRole == "company"
        ? await postReq("company/clients/dropdown", {})
        : permissions.includes("add_requirements")
          ? await postReq("common/clients/dropdown", {})
          : { status: 201 };

    if (response.status == 200) {
      setClients(response.data);
    } else {
      setClients([]);
    }
  };
  const getRequirementList = async (newQuery = query) => {
    try {
      if (!userDetails) return;
      setIsLoading(true);
      let getRes = {};
      if (userRole == "company") {
        getRes = await postReq("/company/requirement/list", {
          ...newQuery,
          status: activeTab,
        });
      } else if (permissions?.includes("view_requirements")) {
        getRes = await postReq("/common/requirement/user/list", {
          ...newQuery,
          status: activeTab,
        });
      } else {
        setIsLoading(false);
      }
      if (getRes.status == 1) {
        setJobData(getRes?.data?.requirements);
        fetchDataTab();
        setIsLoading(false);
      } else {
        setJobData([]);
        fetchDataTab();
        setIsLoading(false);
      }
    } catch (error) {
      console.log("error", error);
      setJobData([]);
      fetchDataTab();
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (!userRole || !userDetails) return;

    getRequirementList(query);
  }, [userRole, activeTab]);

  useEffect(() => {
    if (!userRole || !userDetails) return;

    handleTagsData(true);
    handleTagsData(false);
    fetchClient();
  }, [userRole]);

  const fetchCandidate = async () => {
    const response = await postReq("company/candidate/dropdown", {});

    if (response.status == 200) {
      setCandidate(response.data);
    } else {
      setCandidate(null);
    }
  };

  useEffect(() => {
    fetchCandidate();
  }, []);

  const [form] = Form.useForm();

  const handleClick = () => {
    setShowModal(true);
  };

  const handleCancel = () => {
    setShowModal(false);
    form.resetFields();
  };

  const handleClear = () => {
    form.resetFields();
  };

  const handleSubmit = async (values) => {
    try {
      let postData;
      postData =
        userRole == "company"
          ? await postReq("/company/requirement/create", values, {})
          : permissions.includes("add_requirements")
            ? await postReq("/common/requirement/create", values, {})
            : { status: 0 };
      if (postData.status == 1) {
        getRequirementList(query);
        form.resetFields();
        setShowModal(false);
        notification.success({
          message: "Success",
          description: "The operation was successful.",
          placement: "topRight",
        });
      } else {
        form.resetFields();
        setShowModal(false);
        notification.error({
          message: "Error",
          description:
            postData.message || "There was an error processing your request.",
          placement: "topRight",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description:
          error.message || "There was an error processing your request.",
        placement: "topRight",
      });
      form.resetFields();
      setShowModal(false);
    }
  };
  useEffect(() => {
    const handler = setTimeout(() => {
      getRequirementList(query);
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [query.searchParams]);
  const handleOnChange = (e) => {
    setQuery({ ...query, searchParams: e.target.value });
  };

  const fetchDataTab = async () => {
    const data = await postReq("/common/requirement/dashboard_data", {});
    if (data.status == 1) {
      setNumber(data.data);
    } else {
      setNumber({ open: 0, close: 0, "on-hold": 0 });
    }
  };
  useEffect(() => {
    fetchDataTab();
  }, [jobData]);

  return (
    <>
      <Modal
        title="Post Your Requirement"
        open={showModal}
        onCancel={handleCancel}
        footer={
          <div style={{ paddingTop: "10px" }}>
            <Button
              type="default"
              onClick={handleClear}
              style={{ marginRight: 8 }}
            >
              Reset
            </Button>
            <Button type="primary" onClick={() => form.submit()}>
              Submit
            </Button>
          </div>
        }
        width="70%" // Full width on moblepx
        style={{ top: 20 }}
        bodyStyle={{ padding: 10 }}
        responsive={true}
        className="responsive-modal"
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Requirement Name"
                name="requirementName"
                rules={[
                  { required: true, message: "Please enter requirement name" },
                ]}
              >
                <Input maxLength={20} placeholder="Enter" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Select Client"
                name="clientId"
                rules={[{ required: true, message: "Please select Client" }]}
              >
                <Select placeholder="Select" className="ant-select-selection1">
                  {client.length > 0 &&
                    client.map((data, i) => (
                      <Option key={i} value={`${data.value}`}>
                        {data.label}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Select Requirement Type"
                name="requirementType"
                rules={[
                  { required: true, message: "Please select requirement type" },
                ]}
              >
                <Select placeholder="Select" className="ant-select-selection1">
                  {requirementTypeOptions.length > 0 &&
                    requirementTypeOptions.map((data, i) => (
                      <Option key={i} value={`${data._id}`}>
                        {data.value}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Select Technology Niche"
                name="requirementNiche"
                rules={[
                  { required: true, message: "Please select technology niche" },
                  {
                    validator: (_, value) => {
                      if (!value || value.length < 1) {
                        return Promise.reject(
                          new Error("At least one niche is required"),
                        );
                      }
                      if (value.length > 10) {
                        return Promise.reject(
                          new Error("You can add at most 10 niches"),
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Select
                  mode="multiple" // Enables multi-select
                  placeholder="Technology Niche"
                  allowClear
                  style={{ width: "100%" }}
                  maxTagCount="responsive"
                  optionFilterProp="children"
                >
                  {techNicheOptions.length > 0 &&
                    techNicheOptions.map((data, i) => (
                      <Option key={i} value={`${data._id}`}>
                        {data.value}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Enter Job Location"
                name="jobLocation"
                rules={[
                  { required: true, message: "Please enter job location" },
                ]}
              >
                <Input maxLength={25} placeholder="Enter" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Enter Budget"
                name="budget"
                rules={[{ required: true, message: "Please enter budget" }]}
              >
                <InputNumber
                  maxLength={7}
                  placeholder="Enter"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            label="Enter Job Description"
            name="requirementJobDescription"
            rules={[
              { required: true, message: "Please enter job description" },
              {
                min: 100,
                message: "Description must be at least 100 characters",
              },
            ]}
          >
            <Input.TextArea
              style={{ height: 100, resize: "vertical" }}
              placeholder="Enter"
            />
          </Form.Item>

          <Row gutter={[16, 16]} align="middle">
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                label="Work Status"
                name="workType"
                rules={[
                  { required: true, message: "Please select work type status" },
                ]}
              >
                <Radio.Group>
                  <Radio value="onsite">Onsite</Radio>
                  <Radio value="remote">Remote</Radio>
                  <Radio value="hybrid">Hybrid</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={4}>
              <Form.Item
                label="Vacancy"
                name="vacancy"
                rules={[
                  { required: true, message: "Please enter vacancy" },
                  {
                    type: "number",
                    min: 1,
                    message: "Minimum Vacancy should be at least 1",
                  },
                  {
                    type: "number",
                    max: 999,
                    message:
                      "Maximum Vacancy should be less than or equal to 999",
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="Enter Vacancy"
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={6}>
              <Form.Item
                label="Min. Experience"
                name="minExperience"
                rules={[
                  {
                    required: true,
                    message: "Please enter minimum experience",
                  },
                  {
                    type: "number",
                    min: 1,
                    message: "Minimum Experience should be at least 1 year",
                  },
                  {
                    type: "number",
                    max: 15,
                    message:
                      "Minimum Experience should be less than or equal to 15 years",
                  },
                ]}
              >
                <InputNumber
                  placeholder="Enter Minimum Experience"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={6}>
              <Form.Item
                label="Max. Experience"
                name="maxExperience"
                rules={[
                  {
                    required: true,
                    message: "Please enter maximum experience",
                  },
                  {
                    type: "number",
                    min: 1,
                    message: "Maximum Experience should be at least 1 year",
                  },
                  {
                    type: "number",
                    max: 18,
                    message:
                      "Maximum Experience should be less than or equal to 18 years",
                  },
                ]}
              >
                <InputNumber
                  placeholder="Enter Maximum Experience"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Card
        loading={isLoading}
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px",
              borderRadius: "20px 20px 0px 0px",
              margin: "0px -24px",
            }}
          >
            <div>
              <Title
                level={4}
                style={{
                  marginBottom: 0,
                  fontSize: "20px",
                  fontWeight: "800",
                  color: "#13487D",
                }}
              >
                Requirements
              </Title>
              {/* <Text type="secondary" style={{ fontSize: "14px" }}>
                Dedicated Project
              </Text> */}
            </div>
            <div style={{ display: "inline-flex", gap: "8px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#F4F4F4",
                  borderRadius: "10px",
                  // padding: "10px 16px",
                  width: "300px",
                  boxShadow: "0px 1px 5px rgba(0,0,0,0.1)",
                }}
              >
                <Input
                  placeholder="Search By Requirement"
                  bordered={false}
                  onChange={handleOnChange}
                  style={{
                    fontSize: "16px",
                    color: "#6F6F6F",
                    border: "none",
                  }}
                />
                <svg
                  width="44"
                  height="44"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => setIsSearch(!isSearch)}
                >
                  <rect width="64" height="64" rx="18" fill="#F4F4F4" />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M35.2267 37.1801L40.6511 42.5978C41.1882 43.1342 42.0603 43.134 42.5974 42.5975C43.1343 42.0607 43.1342 41.1893 42.5971 40.6527L37.1763 35.2389C38.2668 33.757 38.9114 31.9269 38.9114 29.9476C38.9114 25.0092 34.8985 21 29.9557 21C25.0129 21 21 25.0092 21 29.9476C21 34.8859 25.0129 38.8951 29.9557 38.8951C31.9255 38.8951 33.7474 38.2586 35.2267 37.1801ZM29.9557 23.7501C33.3793 23.7501 36.159 26.5271 36.159 29.9476C36.159 33.3681 33.3793 36.1452 29.9557 36.1452C26.5321 36.1452 23.7526 33.3681 23.7526 29.9476C23.7526 26.5271 26.5321 23.7501 29.9557 23.7501Z"
                    fill="#13487D"
                  />
                </svg>
              </div>
              {(userRole == "company" ||
                permissions?.includes("add_requirements")) && (
                <svg
                  width="44"
                  height="44"
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={handleClick}
                  style={{ cursor: "pointer" }}
                >
                  <rect width="64" height="64" rx="18" fill="#F4F4F4" />
                  <path
                    d="M32 22V42"
                    stroke="#13487D"
                    stroke-width="2.7"
                    stroke-linecap="round"
                  />
                  <path
                    d="M42 32L22 32"
                    stroke="#13487D"
                    stroke-width="2.7"
                    stroke-linecap="round"
                  />
                </svg>
              )}
            </div>
          </div>
        }
        style={{ paddingLeft: "16px", color: "#13487D" }}
      >
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={[
            {
              key: "open",
              label: `Open ${number["open"]}`,
            },
            {
              key: "close",
              label: `Closed ${number["close"]}`,
            },
            {
              key: "on-hold",
              label: `Hold ${number["on-hold"]}`,
            },
          ]}
        />
        {jobData.length > 0 ? (
          <Row
            gutter={{
              xs: 8,
              sm: 16,
              md: 24,
              lg: 32,
            }}
          >
            {jobData.map((data, i) => (
              <Col
                className="gutter-row"
                xs={32}
                sm={16}
                md={8}
                lg={8}
                style={{ marginBottom: "10px" }}
              >
                <CardComponent
                  key={i}
                  requirementName={data.requirementName}
                  jobId={data.jobId}
                  requirementType={data.requirementType}
                  maxExperience={data.maxExperience}
                  minExperience={data.minExperience}
                  jobLocation={data.jobLocation}
                  requirementNiche={data.requirementNiche}
                  requirementStatus={data.requirementStatus}
                  workType={data.workType}
                  vacancy={data.vacancy}
                  budget={data.budget}
                  client={data.client}
                  data={data}
                  fetch={getRequirementList}
                  candidate={data.appliedCandidate}
                  followups={data.followups}
                  candidates={candidate}
                />
              </Col>
            ))}
          </Row>
        ) : (
          <Empty description="No Data Available" />
        )}
      </Card>
    </>
  );
};

export default Requirements;
